import { restClient } from '@/Core'

import { APPLICATION_REST_URL } from '../Contracts/IApplication'

/** Дієслівні переходи заявки (`SPEC-021` §5.4, маршрути `POST …/{uuid}/<перехід>`). */
export type ApplicationTransition = 'lose' | 'report_problem' | 'resolve_problem'

const asRecord = (response: unknown): Record<string, unknown> | null =>
    response !== null && typeof response === 'object' ? (response as Record<string, unknown>) : null

/**
 * Перехід заявки — `POST /services/applications/{uuid}/<перехід>` (`SPEC-021` §6.1).
 *
 * Відповідь — оновлена картка; `?permissions=true` просить разом із нею
 * `_permissions`, щоб кнопки одразу показали новий стан. Чи можна перехід —
 * вирішує бек: 400 «Недозволений перехід.», 422 — поле тіла.
 */
export const RunApplicationTransitionTask = async (
    uuid: string,
    transition: ApplicationTransition,
    body: Record<string, unknown>
): Promise<Record<string, unknown> | null> =>
    asRecord(
        (await restClient.post(`${APPLICATION_REST_URL}/${encodeURIComponent(uuid)}/${transition}?permissions=true`, {
            json: body,
        })) as unknown
    )

/**
 * Часткове збереження заявки з кнопок картки — «Оновити статус»
 * (`statusClient`) і «Вивантажився» (`dateUnloading`), як у легасі
 * (`useButtons4DrawerExtra.jsx:31`, `:86` — `PATCH`). Резолвер статусу й
 * W-A — на беку.
 */
export const PatchApplicationTask = async (
    uuid: string,
    body: Record<string, unknown>
): Promise<Record<string, unknown> | null> =>
    asRecord(
        (await restClient.patch(`${APPLICATION_REST_URL}/${encodeURIComponent(uuid)}?permissions=true`, {
            json: body,
        })) as unknown
    )
